import React, { useState } from 'react';
import { Application } from '../../../../../../../../entities/Application';
import { User } from '../../../../../../../../entities/User';
import { AccountIntegration } from '../../../../../../../../entities/AccountIntegration';
import {
  AlertObject,
  AlertType,
} from '../../../../../../../../components/Alert';
import { IconButton } from '../../../../../../../../components/IconButton';
import { SendEmailModal } from '../../../../../../../SendEmailModal';
import { ApplicationService } from '../../../../../../../../services/applicant_tracking/ApplicationService';
import { SendEmailDto } from '../../../../../../../../services/dtos/EmailDto';
import { ApiError } from '../../../../../../../../services/ApiService/errors/ApiError';

interface PropTypes {
  application: Application;
  currentUser: User;
  emailAccountIntegration: AccountIntegration;
  setAlert: (alert: AlertObject) => void;
}

export function SendEmail(props: PropTypes) {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  if (!props.emailAccountIntegration.enabled) {
    return null;
  }

  const isRedacted = props.application.redacted;
  const tooltipText = isRedacted
    ? 'E-mail sending is only available for not-redacted candidates'
    : 'Send Email';

  const onSendEmail = async (sendEmailProps: SendEmailDto) => {
    try {
      await ApplicationService.sendEmails(
        [props.application.id],
        sendEmailProps,
      );
      props.setAlert({
        type: AlertType.Success,
        message: 'The email was successfully sent.',
      });
    } catch (e) {
      const error = e as ApiError;
      props.setAlert({
        type: AlertType.Danger,
        message: error.body?.message || 'The email was not sent.',
      });
    } finally {
      setIsModalOpen(false);
    }
  };

  return (
    <>
      {isModalOpen && (
        <SendEmailModal
          applicationIds={[props.application.id]}
          toEmail={props.application.candidate.email}
          hasEmailConnected={props.currentUser.hasEmailConnected}
          isOpen={isModalOpen}
          onCloseModal={() => setIsModalOpen(false)}
          onSendEmail={onSendEmail}
        />
      )}
      <IconButton
        iconName='bi-envelope'
        iconClass='text-info'
        buttonClass='me-2h'
        color='secondary'
        tooltipText={tooltipText}
        disabled={isRedacted}
        onClick={() => setIsModalOpen(true)}
      />
    </>
  );
}
